import { OneTrustCookiesList } from "./OneTrustCookiesList";

export { OneTrustCookiesList };
